var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 402.77 95.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003c56;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.66 83.62 0 83.62 0 71.53 54.66 69.11 54.66 83.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -23.92,
    y: 35.56,
    width: 62.4,
    height: 14.56,
    transform: "translate(-35.56 50.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.97,
    y: 42.8,
    width: 89.25,
    height: 15.19,
    transform: "translate(20.2 120.98) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 132.45,
    y: 42.8,
    width: 89.25,
    height: 15.19,
    transform: "translate(126.69 227.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "290.58 11.05 278.85 54.02 264.27 49.45 276 6.48 290.58 11.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "257.59 26.56 205.45 15.75 205.43 0.67 260.71 13.74 257.59 26.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.94 24.28 3.13 24.28 0.06 11.63 54.6 11.87 52.94 24.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.66 14.07 50.08 77.85 36.39 78.32 40.02 12.63 53.66 14.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "184.67 10.67 184.67 4.89 169.48 0.67 169.48 5.76 184.67 10.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "78.19 10.67 78.19 5.76 63 0.67 63 5.76 78.19 10.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.08 0.67 93.29 9.5 93.29 24.28 73.8 17.18 63.08 0.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.88,50.39a22.51,22.51,0,1,0,22.5,22.5A22.51,22.51,0,0,0,329.88,50.39Zm0,34.58A12.08,12.08,0,1,1,342,72.89,12.08,12.08,0,0,1,329.88,85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.39,17.82a30.83,30.83,0,1,0,30.82,30.82A30.82,30.82,0,0,0,129.39,17.82Zm0,46.38a15.56,15.56,0,1,1,15.55-15.56A15.56,15.56,0,0,1,129.39,64.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.71,13.74l-8,33S227.54,62.38,205.43,66V50.81s18.18-2.71,38.46-14.49c-37.78,2.5-38.46,2.5-38.46,2.5V27.25l39.63-2.81-39.61-8.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.81 7.16 277.42 0.67 290.58 11.05 289.33 14.67 275.81 7.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.21 52.69 277.13 60.82 264.27 49.45 268 46.16 279.21 52.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "212.55 68.7 285.85 63.01 277.21 95.02 260.24 95.02 267.47 77.68 212.55 84.7 212.55 68.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "258.41 95.02 331.29 95.4 329.88 87.9 270.55 91.65 258.41 95.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.88,31.11a41.64,41.64,0,0,0-13.42,2.22l-4.12,16.12a28.89,28.89,0,0,1,14.56-5.72,29.18,29.18,0,0,1,22,51.18h16.28a41.66,41.66,0,0,0-35.3-63.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.77,72.89A72.9,72.9,0,0,0,329.88,0c-1.46,0-2.91.06-4.35.14l-3.57,14c.62-.08,1.24-.16,1.87-.22a59.29,59.29,0,0,1,65,65,57.89,57.89,0,0,1-4,16.08h14.47A72.88,72.88,0,0,0,402.77,72.89Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e11fb428c342e80af001c0da03428bc2.svg";
export { ForwardRef as ReactComponent };